(() => {
  const init = (root) => {
    if (!root || root.dataset.croProductReady === 'true') return;

    const marker = root.querySelector('[data-cro-product]');
    const sticky = root.querySelector('[data-cro-sticky]');
    const stickyButton = root.querySelector('[data-cro-sticky-button]');
    const stickyPrice = root.querySelector('[data-cro-sticky-price]');
    const addButton = root.querySelector('product-form [name="add"]');
    const price = root.querySelector('[id^="price-"]');
    const description = root.querySelector('.product__description');

    if (!marker || !sticky || !stickyButton || !addButton) return;

    root.dataset.croProductReady = 'true';
    root.classList.add('cro-product');

    const primaryMediaIndex = Number.parseInt(marker.dataset.croPrimaryMedia || '', 10);
    if (primaryMediaIndex > 1) {
      window.requestAnimationFrame(() => {
        root.querySelectorAll('media-gallery .thumbnail')[primaryMediaIndex - 1]?.click();
      });
    }

    const title = root.querySelector('.product__title h1');
    if (title) {
      const fullTitle = title.textContent.trim();
      const conciseTitle = fullTitle.split(/\s[–—-]\s/, 1)[0].trim();
      const requestedTitle = marker.dataset.croTitle?.trim();
      if (requestedTitle) title.textContent = requestedTitle;
      else if (conciseTitle.length >= 8 && conciseTitle.length <= 72) title.textContent = conciseTitle;
    }

    const cleanText = (value) => value
      .replace(/\s+/g, ' ')
      .replace(/Metalic/g, 'Metallic')
      .trim();
    const shorten = (value, limit = 180) => {
      const text = cleanText(value);
      if (text.length <= limit) return text;
      const sentenceEnd = text.lastIndexOf('.', limit);
      if (sentenceEnd >= 70) return text.slice(0, sentenceEnd + 1);
      const clipped = text.slice(0, limit - 1);
      const lastSpace = clipped.lastIndexOf(' ');
      return `${clipped.slice(0, lastSpace > 70 ? lastSpace : clipped.length).trim()}…`;
    };

    if (description) {
      const benefit = root.querySelector('[data-cro-benefit]');
      if (benefit?.hidden) {
        const paragraph = Array.from(description.querySelectorAll('p')).find((item) => cleanText(item.textContent).length >= 45);
        if (paragraph) {
          benefit.textContent = shorten(paragraph.textContent, 150);
          benefit.hidden = false;
        }
      }

      const facts = root.querySelector('[data-cro-facts]');
      if (facts?.hidden) {
        const listCandidates = Array.from(description.querySelectorAll('li'))
          .map((item) => cleanText(item.textContent))
          .filter((text) => text.length >= 8 && text.length <= 110);
        const bulletCandidates = description.textContent
          .split('•')
          .slice(1)
          .map(cleanText)
          .filter((text) => text.length >= 8 && text.length <= 110);
        const candidates = [...new Set([...listCandidates, ...bulletCandidates])]
          .filter((text) => !/umtausch|rückgabe|versand|liefer/i.test(text))
          .slice(0, 3);

        candidates.forEach((text) => {
          const item = document.createElement('li');
          item.textContent = text;
          facts.appendChild(item);
        });
        facts.hidden = candidates.length === 0;
      }

      const delivery = root.querySelector('[data-cro-delivery]');
      if (delivery?.hidden) {
        const deliverySource = Array.from(description.querySelectorAll('p, li'))
          .map((item) => cleanText(item.textContent))
          .find((text) => /versand|lieferzeit|fertigungszeit|versandfertig/i.test(text) && text.length <= 160);

        if (deliverySource) {
          const deliveryText = shorten(deliverySource, 120);
          const deliveryTarget = delivery.querySelector('[data-cro-delivery-text]');
          const assuranceDelivery = root.querySelector('[data-cro-assurance-delivery]');
          if (deliveryTarget) deliveryTarget.textContent = deliveryText;
          if (assuranceDelivery) {
            assuranceDelivery.textContent = deliveryText;
            assuranceDelivery.hidden = false;
          }
          delivery.hidden = false;
        }
      }
    }

    const fallbackKanjiField = root.querySelector('[data-cro-kanji-custom-field]');
    const kanjiGroup = Array.from(root.querySelectorAll('variant-radios fieldset, variant-selects fieldset, fieldset.product-form__input'))
      .find((group) => /Kanji\s*Zeichen/i.test(group.querySelector('legend, .form__label')?.textContent || ''));
    const individualKanji = kanjiGroup
      ? Array.from(kanjiGroup.querySelectorAll('input[type="radio"]')).find((input) => input.value?.trim() === 'Individuell')
      : null;

    const isVisibleField = (field) => Boolean(
      field
      && !field.disabled
      && !field.closest('[hidden]')
      && (field.offsetWidth || field.offsetHeight || field.getClientRects().length)
    );

    const rawTextifyFields = () => {
      const mount = root.querySelector('#textfieldapp');
      if (!mount) return { color: null, custom: null };

      const color = mount.querySelector('select');
      const custom = Array.from(mount.querySelectorAll('textarea, input[type="text"]'))
        .find((field) => !field.id?.startsWith('form_cloneInputValue_')) || null;

      return { color, custom };
    };

    const textifyFields = () => {
      const fields = rawTextifyFields();
      return {
        color: isVisibleField(fields.color) ? fields.color : null,
        custom: isVisibleField(fields.custom) ? fields.custom : null,
      };
    };

    const syncPersonalizationSource = (isIndividual) => {
      const fallbackRoot = root.querySelector('[data-cro-kanji-options]');
      const textify = rawTextifyFields();
      const hasTextify = Boolean(textify.color || textify.custom);

      if (fallbackRoot) {
        fallbackRoot.hidden = hasTextify;
        fallbackRoot.querySelectorAll('input, select, textarea, button').forEach((field) => {
          field.disabled = hasTextify;
          if (hasTextify) {
            field.required = false;
            field.setCustomValidity?.('');
          }
        });
      }

      if (textify.custom) {
        if (!isIndividual && textify.custom.value) {
          textify.custom.value = '';
          textify.custom.dispatchEvent(new Event('input', { bubbles: true }));
        }
        const customContainer = textify.custom.closest('.textbox_combined_fields');
        if (customContainer) customContainer.hidden = !isIndividual;
        textify.custom.disabled = !isIndividual;
        textify.custom.required = isIndividual;
        textify.custom.setAttribute('aria-required', String(isIndividual));
        if (!isIndividual) textify.custom.setCustomValidity('');
      }
    };

    const personalizationFields = () => {
      const textify = textifyFields();
      const fallbackRoot = root.querySelector('[data-cro-kanji-options]:not([hidden])');
      return {
        color: textify.color || fallbackRoot?.querySelector('select[name="properties[Prägungsfarbe]"]') || null,
        custom: textify.custom || fallbackRoot?.querySelector('[data-cro-kanji-custom-field]') || null,
      };
    };

    const selectedKanjiIsIndividual = () => {
      if (!kanjiGroup) return false;
      const selectedKanji = kanjiGroup.querySelector('input[type="radio"]:checked');
      return selectedKanji?.value?.trim() === 'Individuell';
    };

    const colorIsMissing = (field) => !field?.value?.trim() || field.value.trim().toLowerCase() === 'choose';

    const syncKanjiState = () => {
      const isIndividual = selectedKanjiIsIndividual();
      syncPersonalizationSource(isIndividual);
      const { color, custom } = personalizationFields();

      if (color) {
        color.required = true;
        color.setAttribute('aria-required', 'true');
        color.setCustomValidity(colorIsMissing(color) ? 'Bitte wähle eine Farbe für die Lederprägung.' : '');
      }

      if (custom) {
        custom.required = isIndividual;
        custom.setAttribute('aria-required', String(isIndividual));
        custom.setCustomValidity(isIndividual && !custom.value.trim() ? 'Bitte trage dein Wunschzeichen ein.' : '');
        if (!isIndividual && custom.value) {
          custom.value = '';
          custom.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      if (fallbackKanjiField && fallbackKanjiField !== custom && fallbackKanjiField.closest('[hidden]')) {
        fallbackKanjiField.required = false;
        fallbackKanjiField.disabled = true;
        fallbackKanjiField.setCustomValidity('');
      }
    };

    if (individualKanji) {
      root.addEventListener('input', (event) => {
        const { custom } = personalizationFields();
        if (event.target === custom && custom.value.trim() && !individualKanji.checked) individualKanji.click();
      });
      kanjiGroup.addEventListener('change', syncKanjiState);
      syncKanjiState();
    }

    const requestedLabel = marker.dataset.croCtaLabel || 'In den Warenkorb';
    const findMissingAppField = () => {
      const { color, custom } = personalizationFields();
      if (color && colorIsMissing(color)) return color;
      if (custom && selectedKanjiIsIndividual() && !custom.value.trim()) return custom;

      return Array.from(root.querySelectorAll('#textfieldapp [required], .cro-kanji-options:not([hidden]) [required]')).find((field) => {
      if (field.disabled || field.closest('[hidden]')) return false;
      if (field.type === 'checkbox' || field.type === 'radio') return !field.checked;
      return !field.value?.trim();
      });
    };

    const syncState = () => {
      stickyButton.disabled = addButton.disabled;
      stickyButton.setAttribute('aria-disabled', String(addButton.disabled));
      const stickyLabel = findMissingAppField() ? 'Personalisierung ausfüllen' : requestedLabel;
      if (stickyButton.textContent.trim() !== stickyLabel) stickyButton.textContent = stickyLabel;
      const nativeButtonLabel = addButton.querySelector('span:not(.sold-out-message)');
      if (!addButton.disabled && nativeButtonLabel?.textContent.trim() !== requestedLabel) {
        nativeButtonLabel.textContent = requestedLabel;
      }
      if (price && stickyPrice) {
        const visiblePrice = price.querySelector('.price-item--sale, .price-item--regular');
        if (visiblePrice?.textContent.trim()) stickyPrice.textContent = visiblePrice.textContent.trim();
      }
    };

    syncState();

    const productForm = addButton.closest('form');
    productForm?.addEventListener('submit', (event) => {
      syncKanjiState();
      const missingAppField = findMissingAppField();
      if (!missingAppField) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      missingAppField.reportValidity?.();
      missingAppField.focus({ preventScroll: true });
      missingAppField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);

    const textifyMount = root.querySelector('#textfieldapp');
    if (textifyMount) {
      const personalizationObserver = new MutationObserver(() => {
        syncKanjiState();
        syncState();
      });
      personalizationObserver.observe(textifyMount, {
        childList: true,
        subtree: true,
      });
    }
    [250, 1000].forEach((delay) => window.setTimeout(() => {
      syncKanjiState();
      syncState();
    }, delay));

    const buttonObserver = new MutationObserver(syncState);
    buttonObserver.observe(addButton, { attributes: true, childList: true, subtree: true });
    if (price) buttonObserver.observe(price, { childList: true, subtree: true });
    root.addEventListener('input', syncState);
    root.addEventListener('change', () => {
      syncKanjiState();
      syncState();
      window.setTimeout(() => {
        syncKanjiState();
        syncState();
      }, 150);
    });

    let normalButtonVisible = true;
    const updateSticky = () => {
      const shouldShow = window.scrollY > 220 && !normalButtonVisible;
      sticky.hidden = !shouldShow;
    };

    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        normalButtonVisible = entry.isIntersecting;
        updateSticky();
      },
      { threshold: 0.05 }
    );
    visibilityObserver.observe(addButton);
    window.addEventListener('scroll', updateSticky, { passive: true });

    stickyButton.addEventListener('click', () => {
      const missingAppField = findMissingAppField();

      if (missingAppField) {
        missingAppField.focus({ preventScroll: true });
        missingAppField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (addButton.disabled) {
        const firstChoice = root.querySelector('variant-selects, variant-radios, [data-app-block]');
        firstChoice?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      addButton.click();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('product-info').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
